<section *ngFor="let item of kioskItems">
  <div class="item-container clover-kiosk-item-list {{ !item.tmsAvailable ? 'opacity-div' : '' }}" fxLayoutGap="20px">
    <div class="item">
      <div fxFlex="20">
        <img class="item-image" [src]="item.imageBase64" [alt]="item.title" />
      </div>
      <div fxFlex="80" class="item-description">
        <div class="title-msg-div">
          <h3 class="item-title">{{ item.title }}</h3>
          <p class="unavailable-msg" *ngIf="item.tmsAvailable === false">(Indisponível)</p>
        </div>
        <p>{{ item.description }}</p>
      </div>
    </div>
    <div class="item-selector">
      <mat-form-field>
        <mat-label>Quantidade</mat-label>
        <mat-select [(value)]="item.selectedQuantity" (selectionChange)="onQuantityChange()" [disabled]="!item.tmsAvailable">
          <mat-option style="color: #616365" *ngFor="let qty of getAvailableOptions(item)" [value]="qty">
            {{ qty }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</section>
